import React from "react";
import Page from "../../common/page/Page.js";
import WithRedirectionUserIsAuthorized from "../../authentication-ui/WithRedirectionUserIsAuthorized.js";
import useAuthUser from "../../authentication-no-ui/useAuthUser.js";
import useShowLoader from "../../common/loading-widgets/useShowLoader.js";
import useTranslationSponsorship from "../useTranslationSponsorship.js";
import SponsoredListBlock from "./SponsoredListBlock.js";

export default function SponsoredListPage(/*props*/) {
  const { profile: recruiter } = useAuthUser();
  const { t, loading: tLoading } = useTranslationSponsorship();
  useShowLoader(tLoading);

  return (
    <WithRedirectionUserIsAuthorized
      yes={() => (
        <Page className="SponsoredListPage">
          <Page.Title
            text={t("sponsorship:sponsored_page_title")}
            loading={tLoading}
          />
          <Page.Content>
            <SponsoredListBlock recruiterId={recruiter._id} />
          </Page.Content>
        </Page>
      )}
    />
  );
}
